import React from 'react';

const FollowUps = ({ userId }) => {
    return (
        <div className="text-muted text-center py-5">
            <h6>Follow-ups</h6>
            <p className="small mb-0">Follow-up alerts and actions will appear here.</p>
        </div>
    );
};

export default FollowUps;
